import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      gap: '16px',
      borderRadius: '5.25px',
      padding: '15px',
      boxShadow: '-4px 4px 22px -2px rgba(67, 67, 67, 0.15)',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '10px',
    },
    headerTitle: {
      display: 'flex',
      flexDirection: 'column',
    },
    headerTitleName: {
      fontSize: '18px',
      color: 'rgba(0, 122, 255, 1)',
    },
    headerTitleInvestors: {
      fontSize: '11px',
      color: 'rgba(129, 128, 128, 1)',
    },
    divider: {
      width: '100%',
      height: '1px',
      backgroundColor: 'rgba(203, 203, 203, 1)',
    },
    body: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',

      '@media (max-width: 768px)': {
        justifyContent: 'initial',
        gap: '20px',
      }
    },
    bodyColumn: {
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
    },
    infoTitle: {
      fontWeight: 700,
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      fontSize: '11px',
      color: 'rgba(129, 128, 128, 1)',
    },
    feeTile: {
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      fontSize: '11px',
      color: 'rgba(129, 128, 128, 1)',
    },
    text: {
      color: '#505050',
      fontFamily: 'Roboto',
      fontSize: '0.75rem',
      whiteSpace: 'nowrap',
    },
    greenAmount: {
      color: '#1DCD9A',
    },
    amount: {
      display: 'inline-block',
      fontFamily: 'Roboto',
      fontSize: '1.5rem',

      '&::first-letter': {
        fontSize: '1rem',
        paddingRight: '0.25rem',
      }
    }
  }
))
